var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 170,
    viewBox: "0 0 154 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M124.933 0.416992H29.0666C10.2722 0.416992 0.875 9.8142 0.875 28.6086V113.192C0.875 131.998 10.2722 141.398 29.0666 141.392H41.7541C43.9429 141.392 46.1016 141.901 48.0599 142.879C50.0181 143.856 51.7222 145.276 53.0375 147.025L65.725 163.942C67.0376 165.693 68.7398 167.114 70.6968 168.093C72.6538 169.071 74.8119 169.581 77 169.581C79.1881 169.581 81.3462 169.071 83.3032 168.093C85.2602 167.114 86.9624 165.693 88.275 163.942L100.962 147.025C102.278 145.276 103.982 143.856 105.94 142.879C107.898 141.901 110.057 141.392 112.246 141.392H124.933C143.728 141.392 153.125 131.992 153.125 113.192V28.6086C153.125 9.8142 143.728 0.416992 124.933 0.416992Z",
    fill: "#338AF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.632 71.9068C111.38 98.9735 77.0897 114.604 77.0897 114.604C77.0897 114.604 42.7996 98.9989 37.547 71.9068C34.3244 55.2862 41.3617 38.5641 59.2342 38.4795C63.2028 38.6663 67.0236 40.0422 70.2002 42.4285C73.3768 44.8147 75.7625 48.101 77.0474 51.8606C78.3349 48.0946 80.7271 44.8037 83.912 42.4169C87.0969 40.0301 90.9269 38.658 94.9029 38.4795C112.852 38.5641 119.855 55.2862 116.632 71.9068Z",
    fill: "#338AF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartTag);
export default __webpack_public_path__ + "static/media/heart-tag.63403cc04b5e448ddaf887625b6d0ad4.svg";
export { ForwardRef as ReactComponent };